<template>
  <div class="recommendations">
    <div
      class="recommendations-tabs"
      v-if="!isEmpty(tabs)"
      style="margin-bottom: 60px"
    >
      <v-row>
        <v-col class="pl-4 pr-4">
          <p class="recommendations-title">
            {{ mess["recommendations_tabs_title"] }}
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="pa-0">
          <v-tabs
            v-model="tab"
            class="recommendation-steps"
            background-color="transparent"
            color="primary"
            :show-arrows="false"
            hide-slider
          >
            <v-tab v-for="(tabItem, i) in tabs" :key="`tab-${i}`">
              {{ tabItem.title }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="pa-0">
          <v-tabs-items v-model="tab" :value="tab.tabIndex">
            <v-tab-item v-for="(tabItem, i) in tabs" :key="`tab-item-${i}`">
              <v-data-table
                :headers="headers || []"
                :items="tabItem.items || []"
                :locale="'ru'"
                hide-default-footer
                class="recommendations-table elevation-0"
              >
                <template v-slot:header.price="{ header }">
                  <div class="text-no-wrap">
                    <span>{{ header.text }}</span>
                    <v-tooltip right content-class="table-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" dark v-bind="attrs" v-on="on">
                          mdi-alert-circle-outline
                        </v-icon>
                      </template>
                      <span>{{ mess["price_tooltip"] }}</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:header.availability="{ header }">
                  <span v-html="header.text"> </span>
                </template>
                <template v-slot:item.name="{ item }">
                  <a class="link link--table" :href="item.link" target="_blank">
                    {{ item.name }}
                  </a>

                  <svg
                    v-if="item.reference"
                    width="14"
                    height="14"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="ml-2"
                  >
                    <path
                      d="M2.5 14.25C2.2536 14.2507 2.00951 14.2024 1.78186 14.1081C1.55421 14.0138 1.34752 13.8753 1.17375 13.7006L0.208752 12.8419C0.0849286 12.7315 0.0100319 12.5764 0.000537856 12.4108C-0.00895617 12.2452 0.0477302 12.0826 0.158127 11.9588C0.268523 11.8349 0.423586 11.76 0.589204 11.7505C0.754822 11.741 0.917429 11.7977 1.04125 11.9081L2.03188 12.7919C2.08859 12.8556 2.15773 12.907 2.23505 12.9429C2.31237 12.9789 2.39623 12.9987 2.48147 13.001C2.56672 13.0033 2.65154 12.9882 2.73072 12.9566C2.80989 12.9249 2.88176 12.8774 2.94188 12.8169L5.19188 10.6725C5.25065 10.6127 5.32084 10.5654 5.39828 10.5333C5.47571 10.5012 5.55882 10.485 5.64264 10.4857C5.72646 10.4864 5.80928 10.5039 5.88619 10.5373C5.96309 10.5706 6.0325 10.6191 6.09029 10.6798C6.14807 10.7406 6.19306 10.8123 6.22256 10.8907C6.25205 10.9692 6.26547 11.0528 6.262 11.1365C6.25854 11.2203 6.23826 11.3025 6.20237 11.3783C6.16649 11.454 6.11573 11.5218 6.05313 11.5775L3.8125 13.7113C3.63986 13.8829 3.43508 14.0188 3.20987 14.1113C2.98466 14.2037 2.74344 14.2508 2.5 14.25ZM14.375 13.625H8.125C7.95924 13.625 7.80027 13.5592 7.68306 13.4419C7.56585 13.3247 7.5 13.1658 7.5 13C7.5 12.8342 7.56585 12.6753 7.68306 12.5581C7.80027 12.4409 7.95924 12.375 8.125 12.375H14.375C14.5408 12.375 14.6997 12.4409 14.8169 12.5581C14.9342 12.6753 15 12.8342 15 13C15 13.1658 14.9342 13.3247 14.8169 13.4419C14.6997 13.5592 14.5408 13.625 14.375 13.625ZM2.5 9.25C2.2536 9.25065 2.00951 9.20243 1.78186 9.10813C1.55421 9.01383 1.34752 8.87533 1.17375 8.70063L0.183127 7.71C0.0692778 7.59213 0.00628124 7.43425 0.00770526 7.27038C0.00912927 7.1065 0.0748599 6.94975 0.19074 6.83387C0.30662 6.71799 0.463378 6.65226 0.627251 6.65083C0.791124 6.64941 0.949 6.7124 1.06688 6.82625L2.05813 7.81688C2.17711 7.93065 2.33538 7.99414 2.5 7.99414C2.66462 7.99414 2.8229 7.93065 2.94188 7.81688L5.19188 5.6725C5.31189 5.55796 5.47248 5.49579 5.63834 5.49966C5.80419 5.50352 5.96171 5.57312 6.07625 5.69313C6.19079 5.81314 6.25297 5.97373 6.2491 6.13959C6.24523 6.30544 6.17564 6.46296 6.05563 6.5775L3.8125 8.71125C3.63986 8.88289 3.43508 9.01881 3.20987 9.11126C2.98466 9.2037 2.74344 9.25085 2.5 9.25ZM14.375 8.625H8.125C7.95924 8.625 7.80027 8.55916 7.68306 8.44195C7.56585 8.32473 7.5 8.16576 7.5 8C7.5 7.83424 7.56585 7.67527 7.68306 7.55806C7.80027 7.44085 7.95924 7.375 8.125 7.375H14.375C14.5408 7.375 14.6997 7.44085 14.8169 7.55806C14.9342 7.67527 15 7.83424 15 8C15 8.16576 14.9342 8.32473 14.8169 8.44195C14.6997 8.55916 14.5408 8.625 14.375 8.625ZM2.5 4.25C2.2536 4.25065 2.00951 4.20243 1.78186 4.10813C1.55421 4.01383 1.34752 3.87533 1.17375 3.70063L0.208752 2.84188C0.0849286 2.73148 0.0100319 2.57642 0.000537856 2.4108C-0.00895617 2.24518 0.0477302 2.08258 0.158127 1.95875C0.268523 1.83493 0.423586 1.76003 0.589204 1.75054C0.754822 1.74105 0.917429 1.79773 1.04125 1.90813L2.03188 2.79188C2.08859 2.85556 2.15773 2.90697 2.23505 2.94293C2.31237 2.9789 2.39623 2.99866 2.48147 3.001C2.56672 3.00334 2.65154 2.98822 2.73072 2.95655C2.80989 2.92489 2.88176 2.87735 2.94188 2.81688L5.19438 0.672504C5.3155 0.564673 5.47379 0.508141 5.63582 0.514848C5.79784 0.521556 5.95092 0.590977 6.06272 0.708451C6.17451 0.825924 6.23627 0.98225 6.23494 1.14441C6.23362 1.30657 6.16932 1.46187 6.05563 1.5775L3.8125 3.71125C3.63986 3.88289 3.43508 4.01882 3.20987 4.11126C2.98466 4.2037 2.74344 4.25085 2.5 4.25ZM14.375 3.625H8.125C7.95924 3.625 7.80027 3.55916 7.68306 3.44195C7.56585 3.32474 7.5 3.16576 7.5 3C7.5 2.83424 7.56585 2.67527 7.68306 2.55806C7.80027 2.44085 7.95924 2.375 8.125 2.375H14.375C14.5408 2.375 14.6997 2.44085 14.8169 2.55806C14.9342 2.67527 15 2.83424 15 3C15 3.16576 14.9342 3.32474 14.8169 3.44195C14.6997 3.55916 14.5408 3.625 14.375 3.625Z"
                      fill="#EA5432"
                    />
                  </svg>
                </template>
                <template v-slot:item.availability="{ item }">
                  {{ item.available }} / {{ item.transit }}
                </template>
                <template v-slot:item.price="{ item }">
                  <span style="white-space: nowrap">{{ item.price }}</span>
                </template>
                <template v-slot:item.quantity="{ item }">
                  <button-counter
                    v-model="item.quantity"
                    :item="item"
                    :lock-quantity="false"
                  >
                  </button-counter>
                </template>
                <template v-slot:item.action="{ item }">
                  <action-buttons
                    :item="item"
                    :buttons="['cart', 'wishlist']"
                    :icons="false"
                    @added-to-cart="$emit('added-to-cart', $event)"
                    @open-wishlist-dialog="$emit('open-wishlist-dialog', item)"
                    @change-cart-items="
                      $store.dispatch('setCartItems', {
                        ...cartItems,
                        ...$event
                      })
                    "
                  >
                  </action-buttons>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
    <div class="recommendations-slider" v-if="!isEmpty(slider)">
      <v-row>
        <v-col class="pl-4 pr-4 pb-0">
          <p class="recommendations-title mb-0">
            {{ mess["recommendations_slider_title"] }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-slide-group
            v-model="model"
            mandatory
            show-arrows
            center-active
            class="recommendations-slider"
          >
            <v-slide-item
              v-for="(slide, i) in slider"
              :key="`slide-${i}`"
              v-slot:default="{ active, toggle }"
            >
              <v-card
                min-height="160"
                width="276"
                outlined
                class="recommendations-slide d-flex flex-column align-center justify-center pa-5"
              >
                <p style="margin-bottom: auto; max-width: 100%">
                  {{ slide.title }}
                </p>
                <v-btn
                  outlined
                  color="primary"
                  tag="a"
                  :href="slide.link"
                  target="_blank"
                  >Перейти</v-btn
                >
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ActionButtons from "@/components/ActionButtons";
import ButtonCounter from "@/components/ButtonCounter";
import isEmpty from "lodash/isEmpty";
import { mapGetters } from "vuex";

export default {
  name: "Recommendations",
  components: {
    ActionButtons,
    ButtonCounter
  },
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    slider: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      isEmpty: isEmpty,
      tab: 0,
      model: null
    };
  },
  computed: {
    ...mapGetters({
      cartItems: "cartItems"
    }),
    headers() {
      return [
        {
          text: this.mess["assembly_element_id"],
          value: "code"
        },
        {
          text: this.mess["assembly_product_name"],
          value: "name",
          sortable: false
        },
        {
          text: this.mess["assembly_oem_article"],
          value: "oem",
          sortable: false
        },
        {
          text: this.mess["e_detail_availability"],
          value: "availability",
          sortable: false
        },
        {
          text: this.mess["assembly_price"],
          value: "price",
          sortable: false
        },
        {
          text: this.mess["assembly_count"],
          value: "quantity",
          sortable: false
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.recommendations-title {
  color: var(--v-primary-base);
  font-size: 20px;
}

.recommendations-table {
  &.v-data-table {
    background: #f5f5f5;
  }

  table th {
    padding: 0 10px;
    font-size: 10px;
    line-height: 14px;
    text-transform: uppercase;
    color: #555 !important;
    letter-spacing: 1px;
    font-weight: 400;
  }

  table td {
    padding: 4px 10px;
    color: #000000;
    font-size: 12px;
    line-height: 1.4;
    //border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;

    @media (max-width: 768px) {
      height: 40px !important;
    }
  }
}

.recommendation-steps {
  &.v-tabs {
    @media (min-width: 768px) {
      padding-left: 40px;
      padding-right: 40px;
    }
  }

  .v-tabs-bar {
    height: auto;
  }

  .v-tab {
    margin-right: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    background: #f5f5f5;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    text-transform: none;
    letter-spacing: normal;

    &::before {
      display: none;
    }
  }
  .v-tab:not(.v-tab--active) {
    box-shadow: inset 0 -4px 4px 0 #ececec;
  }
  .v-tab.v-tab--active {
    color: #000000;
    box-shadow: 0 0 4px 0 #ececec;
  }
  .v-slide-group__prev,
  .v-slide-group__next {
    @media (max-width: 768px) {
      display: none !important;
    }
  }
  .v-slide-group__prev i,
  .v-slide-group__next i {
    font-size: 32px;
    color: var(--v-primary-base);
  }
}

.recommendations-slider {
  .v-slide-group__content {
    padding: 10px 4px;
  }

  .v-slide-group__next i,
  .v-slide-group__prev i {
    font-size: 30px;
    color: #000000;
  }
}

.recommendations-slide {
  margin-right: 12px;
  border-radius: 0 !important;
  transition: box-shadow 150ms;
  transition-delay: unset;

  &:hover {
    box-shadow: 0 0 8px 0 #e6e6e6;
  }
}
</style>
